import type { AppConfig } from '@/types/config'

export const lamourConfig: AppConfig = {
  api: {
    baseUrl: import.meta.env.VITE_API_URL,
    appUrl: import.meta.env.VITE_APP_URL,
    version: 'v1'
  },
  app: {
    id: 'lamour',
    name: 'L\'amour',
    description: 'Romance and Love Stories',
    contentId: 2,
    subscriptionPlanId: 2,
    logo: {
      default: '/assets/images/lamour/logo.svg',
      icon: '/assets/images/lamour/icon.svg'
    }
  },

  theme: {
    colors: {
      primary: '#AA89A9', // Muted purple/mauve (170, 137, 169)
      secondary: '#323232', // Dark gray (50, 50, 50)
      accent: '#CD84CA', // Light purple/pink (205, 132, 202)
      background: '#eee6e9' // Light pink (252, 228, 236)
    },
    dark: {
      primary: '#FFFFFF', // White for dark mode
      secondary: '#AA89A9', // Same muted purple/mauve
      accent: '#CD84CA', // Same light purple/pink
      background: '#FCE4EC' // Same light pink (252, 228, 236)
    },
    fonts: {
      heading: 'Poppins',
      body: 'Poppins'
    },
    form: {
      padding: {
        container: 'py-10 px-6 sm:px-12',
        field: 'space-y-6'
      },
      rounding: {
        button: 'rounded-full',
        input: 'rounded-xl'
      }
    }
  },

  layout: {
    maxWidth: '2xl',
    headerHeight: '16',
    playerHeight: '72px',
    screens: {
      home: [
        {
          "type": "titles",
          "layout": "horizontal",
          "data": {
            "title": "New Releases",
            "list": [],
            "params": {"filter[tag]": "new"}
          },
          "title": "New Releases"
        },
        {
          "type": "titles",
          "layout": "horizontal",
          "data": {
            "title": "Steamy Romance",
            "list": [],
            "params": {"filter[category]": "steamy"}
          },
          "title": "Steamy Romance"
        },
        {
          "type": "titles",
          "layout": "horizontal",
          "data": {
            "title": "Contemporary Romance",
            "list": [],
            "params": {"filter[category]": "contemporary"}
          },
          "title": "Contemporary Romance"
        },
        {
          "type": "titles",
          "layout": "horizontal",
          "data": {
            "title": "Historical Romance",
            "list": [],
            "params": {"filter[category]": "historical"}
          },
          "title": "Historical Romance"
        },
        {
          "type": "titles",
          "layout": "horizontal",
          "data": {
            "title": "Paranormal Romance",
            "list": [],
            "params": {"filter[category]": "paranormal"}
          },
          "title": "Paranormal Romance"
        },
        {
          "type": "categories",
          "layout": "masonry",
          "data": {
            "title": "Browse by Romance Genre",
            "list": [],
            "params": {"limit": 8}
          },
          "title": "Browse by Romance Genre",
          "hideMore": true
        }
      ],
      search: [
        {
          "type": "authors",
          "layout": "horizontal",
          "data": {
            "title": "Popular Romance Authors",
            "list": [],
            "params": {
              "filter[genre]": "romance"
            }
          },
          "title": "Popular Romance Authors"
        },
        {
          "type": "categories",
          "layout": "masonry",
          "data": {
            "title": "Romance Subgenres",
            "list": [],
            "params": {
              "limit": 8,
              "filter[parent]": "romance"
            }
          },
          "title": "Romance Subgenres",
          "limit": 8
        }
      ],
      library: [
        {
          "type": "titles",
          "layout": "horizontal",
          "id": "recently_played",
          "data": {
            "title": "Recently Played",
            "list": [],
            "params": {
              "filter[library]": "played"
            }
          },
          "title": "Recently Played"
        },
        {
          "type": "titles",
          "layout": "horizontal",
          "id": "liked",
          "data": {
            "title": "Favorite Stories",
            "list": [],
            "params": {
              "filter[library]": "liked"
            }
          },
          "title": "Favorite Stories"
        },
        {
          "type": "titles",
          "layout": "grid",
          "id": "purchased",
          "data": {
            "title": "My Romance Library",
            "list": [],
            "params": {
              "filter[library]": "purchased"
            }
          },
          "title": "My Romance Library"
        },
        {
          "type": "titles",
          "layout": "horizontal",
          "id": "bookmarked",
          "data": {
            "title": "Want to Read",
            "list": [],
            "params": {
              "filter[library]": "bookmarked"
            }
          },
          "title": "Want to Read"
        },
        {
          "type": "titles",
          "layout": "horizontal",
          "id": "finished",
          "data": {
            "title": "Completed Stories",
            "list": [],
            "params": {
              "filter[library]": "finished"
            }
          },
          "title": "Completed Stories"
        }
      ]
    }
  },

  features: {
    shop: true,
    ads: false,
    guestMode: true,
    favorites: true,
    darkMode: true,
    search: true,
    player: true,
    sharing: true,
    epubReader: false,
    video: false,
    hasPreview: true
  },

  defaultMode: 'dark' as const,

  subscription: {
    stripePlanId: 'price_1P6nIXGw3TmAggLVuqrtAZ3R',
    price: '3.99',
    currency: 'GBP',
    features: [
      'High Quality Content',
      'Offline Access', 
      'Ad Free Experience',
      'No Commitment',
      'Cancel Anytime'
    ],
    usps: [
      {
        title: 'Premium Audio Quality',
        description: 'Enjoy all content in high-definition audio for the most immersive listening experience.',
        icon: 'headphones'
      },
      {
        title: 'Offline Listening',
        description: 'Download your favorite titles and enjoy them even without internet connection.',
        icon: 'download'
      },
      {
        title: 'Ad-Free Experience',
        description: 'Enjoy uninterrupted listening with no ads or promotions to break your immersion.',
        icon: 'like'
      },
      {
        title: 'Exclusive Content',
        description: 'Get access to subscriber-only titles, early releases, and original productions.',
        icon: 'subscribe'
      }
    ]
  },

  urls: {
    terms: 'https://lamour.plus/terms',
    privacy: 'https://lamour.plus/privacy',
    support: 'https://lamour.plus/support'
  },

  seo: {
    title: 'L\'amour - Romance Audiobooks & Love Stories',
    description: 'Discover passionate romance audiobooks and love stories',
    ogImage: '/assets/images/lamour/og-image.svg',
    defaults: {
      titles: {
        title: 'Romance Audiobooks | L\'amour',
        description: 'Explore our collection of passionate romance audiobooks',
        type: 'article'
      },
      categories: {
        title: 'Romance Genres | L\'amour',
        description: 'Browse romance audiobooks by subgenre and mood',
        type: 'website'
      },
      authors: {
        title: 'Romance Authors | L\'amour',
        description: 'Discover talented romance authors and their passionate stories',
        type: 'website'
      },
      series: {
        title: 'Romance Series | L\'amour',
        description: 'Follow your favorite romance series and characters',
        type: 'website'
      },
      casts: {
        title: 'Narrators | L\'amour',
        description: 'Meet the voices that bring romance stories to life',
        type: 'website'
      }
    }
  }
} 